import {
  aContextActionPage,
  mockEnabledContextActionsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockEnabledContextActionsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          contextActions: aContextActionPage(),
          sumoLogicBaseUrl: 'https://long-www.sumologic.net',
          sumoLogicRegion: 'long',
        },
      });
    }
  ),
];
